import {
  CLIENT,
  CLIENT_CLEAR_DATA,
  CLIENT_ERROR,
  CLIENT_ONE,
  CLIENT_ONE_BY_PROJECT,
  CLIENT_ONE_BY_PROJECT_SUCCESS,
  CLIENT_ONE_CLEAR_DATA,
  CLIENT_ONE_ERROR,
  CLIENT_ONE_SUCCESS,
  CLIENT_SUCCESS,
} from "./actionTypes";

const initialState = {
  loadingClient: false,
  errorClient: null,
  responseClient: null,
  responseOneByProjectClient: null,
  responseOneClient: null,
  loadingOneClient: false,
  errorOneClient: null,
};

const Client = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT:
      state = {
        ...state,
        loadingClient: true,
        errorClient: null,
        responseClient: true,
      };
      break;
    case CLIENT_SUCCESS:
      state = {
        ...state,
        errorClient: null,
        loadingClient: false,
        responseClient: action.payload,
      };
      break;
    case CLIENT_ERROR:
      state = {
        ...state,
        errorClient: action.payload,
        loadingClient: false,
        responseClient: null,
      };
      break;
    case CLIENT_CLEAR_DATA:
      state = {
        ...state,
        errorClient: null,
        loadingClient: null,
        responseClient: false,
      };
      break;
    ///
    case CLIENT_ONE:
      state = {
        ...state,
        loadingOneClient: true,
        errorOneClient: null,
        responseOneClient: null,
      };
      break;
    case CLIENT_ONE_SUCCESS:
      state = {
        ...state,
        errorOneClient: null,
        loadingOneClient: false,
        responseOneClient: action.payload,
      };
      break;
    case CLIENT_ONE_ERROR:
      state = {
        ...state,
        errorOneClient: action.payload,
        loadingOneClient: false,
        responseOneClient: null,
      };
      break;
    case CLIENT_ONE_CLEAR_DATA:
      state = {
        ...state,
        errorOneClient: null,
        loadingOneClient: false,
        responseOneClient: null,
      };
      break;
    ///
    case CLIENT_ONE_BY_PROJECT:
      state = {
        ...state,
        loadingClient: true,
        errorClient: null,
        responseOneByProjectClient: true,
      };
      break;
    case CLIENT_ONE_BY_PROJECT_SUCCESS:
      state = {
        ...state,
        errorClient: null,
        loadingClient: false,
        responseOneByProjectClient: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Client;
